module.exports = "**www.globalpdv.com** uses its own cookies and those of third parties to improve the user's experience.\n"